"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledButtonContent = exports.Link = void 0;
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _StyledIcon = _interopRequireDefault(require("../Icon/StyledIcon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledButtonContent = exports.StyledButtonContent = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1ibjy4q-0"
})([""]);
var Base = _ykbStyledComponents.default.button.withConfig({
  componentId: "ykb-ui__sc-1ibjy4q-1"
})(["display:inline-block;vertical-align:middle;text-align:center;cursor:pointer;outline:0;background-image:none;border:", " ", " transparent;white-space:nowrap;padding:", ";font-size:", ";font-weight:", ";height:", ";border-radius:", ";margin:", ";margin-right:", ";justify-content:center;user-select:none;position:relative;background-color:#fff;&&{", " ", " ", "  &.right-floated,&.right-aligned{margin-right:0px;margin-left:10px;}&.right-floated{float:right;}&.fluid{width:100%;margin:0px;display:block;}&:hover,&:focus{outline:0;}", "  ", "    ", " ", "}"], function (props) {
  return props.theme.button.borderWidth;
}, function (props) {
  return props.theme.button.borderStyle;
}, function (props) {
  return props.theme.button.padding;
}, function (props) {
  return props.theme.button.fontSize;
}, function (props) {
  return props.theme.button.fontWeight;
}, function (props) {
  return props.theme.button.height;
}, function (props) {
  return props.theme.button.borderRadius;
}, function (props) {
  return props.theme.button.marginDefault;
}, function (props) {
  return props.theme.button.marginRight;
}, function (props) {
  return props.hasIcon && (0, _ykbStyledComponents.css)([".icon-wrapper{display:inline-block;vertical-align:middle;line-height:0px;", "{font-size:", ";color:", ";", " ", "}}.text:not(:first-child){display:inline-block;vertical-align:middle;margin-left:10px;}.text:not(:last-child){margin-right:10px;}"], _StyledIcon.default, function (props) {
    return props.theme.button.iconSize;
  }, function (props) {
    return props.theme.button.type[props.colorType].textColor;
  }, function (props) {
    return props.size === 'small' && (0, _ykbStyledComponents.css)(["font-size:", ";"], function (props) {
      return props.theme.button.size.small.iconSize;
    });
  }, function (props) {
    return props.size === 'large' && (0, _ykbStyledComponents.css)(["font-size:", ";"], function (props) {
      return props.theme.button.size.large.iconSize;
    });
  });
}, function (props) {
  return (props.suffix || props.prefix) && (0, _ykbStyledComponents.css)(["display:flex;align-items:center;"]);
}, function (props) {
  return props.$loading && (0, _ykbStyledComponents.css)(["cursor:default;"]);
}, function (props) {
  return props.tabfocus && (0, _ykbStyledComponents.css)(["outline:", " ", " ", ";"], function (props) {
    return props.theme.button.borderWidth;
  }, function (props) {
    return props.theme.button.borderStyle;
  }, function (props) {
    return props.theme.button.tabfocuscolor;
  });
}, function (props) {
  return props.size === 'small' && (0, _ykbStyledComponents.css)(["padding:", ";font-size:", ";font-weight:", ";height:", ";"], function (props) {
    return props.theme.button.size.small.padding;
  }, function (props) {
    return props.theme.button.size.small.fontSize;
  }, function (props) {
    return props.theme.button.size.small.fontWeight;
  }, function (props) {
    return props.theme.button.size.small.height;
  });
}, function (props) {
  return props.size === 'large' && (0, _ykbStyledComponents.css)(["padding:", ";font-size:", ";font-weight:", ";height:", ";"], function (props) {
    return props.theme.button.size.large.padding;
  }, function (props) {
    return props.theme.button.size.large.fontSize;
  }, function (props) {
    return props.theme.button.size.large.fontWeight;
  }, function (props) {
    return props.theme.button.size.large.height;
  });
}, function (props) {
  return props.isIconOnly && (0, _ykbStyledComponents.css)(["padding:", ";"], function (props) {
    return props.size === 'small' ? props.theme.button.size.small.paddingWithIcons : props.size === 'large' ? props.theme.button.size.large.paddingWithIcons : props.theme.button.paddingWithIcons;
  });
});
var buttonView = {
  Link: function Link(props) {
    return (0, _ykbStyledComponents.css)(["&&{border:none;background:none;height:auto;margin:0px;vertical-align:baseline;text-align:left;padding:", ";font-weight:", ";color:", ";text-decoration:", ";margin:", ";background-color:", ";", ";&:hover{color:", ";text-decoration:", ";}", " &:active{color:", ";}}"], props.theme.button.type.link.padding, props.theme.button.type.link.fontWeight, props.theme.button.type.link.textColor, props.theme.button.type.link.textDecoration, props.theme.button.type.link.margin, props.theme.button.type.link.backgroundColor, props.disabled && (0, _ykbStyledComponents.css)(["color:", ";cursor:not-allowed;", "{pointer-events:none;}"], props.theme.button.type.link.textColorDisabled, StyledButtonContent), props.theme.button.type.link.textColorHover, props.theme.button.type.link.textHoverDecoration, function (props) {
      return props.tabfocus && (0, _ykbStyledComponents.css)(["color:", ";text-decoration:", ";"], props.theme.button.type.link.textColorHover, props.theme.button.type.link.textHoverDecoration);
    }, props.theme.button.type.link.textColorPressed);
  },
  Button: function Button(props) {
    return props.colorType === 'ghost' ? (0, _ykbStyledComponents.css)(["&&{padding:", ";margin:", ";border:", ";background-color:", ";&.primary-color{color:", ";}&:hover{&.primary-color{color:", ";}.text ", ":only-child{border-radius:", ";&.default-color{color:", ";background-color:", ";}&.primary-color{color:", ";background-color:", ";}&.success-color{color:", ";background-color:", ";}&.warning-color{color:", ";background-color:", ";}&.danger-color{color:", ";background-color:", ";}}}&:active{&.primary-color{color:", ";}.text ", ":only-child{border-radius:", ";&.default-color{color:", ";background-color:", ";}&.primary-color{color:", ";background-color:", ";}&.success-color{color:", ";background-color:", ";}&.warning-color{color:", ";background-color:", ";}&.danger-color{color:", ";background-color:", ";}}}", " &:disabled{&.primary-color{color:", ";}cursor:not-allowed;", "{background-color:unset !important;}", ".default-color{color:", " !important;}", ".primary-color{color:", " !important;}", ".success-color{color:", " !important;}", ".warning-color{color:", " !important;}", ".danger-color{color:", " !important;}", "{pointer-events:none;}}}"], props.theme.button.type.ghost.padding, props.theme.button.type.ghost.margin, props.theme.button.type.ghost.border, props.theme.button.type.ghost.backgroundColor, function (props) {
      return props.theme.button.type.secondary.textColor;
    }, function (props) {
      return props.theme.button.type.secondary.textColorHover;
    }, _StyledIcon.default, function (props) {
      return props.theme.icon.borderRadius;
    }, function (props) {
      return props.theme.icon.type.default.hoverColor;
    }, function (props) {
      return props.theme.icon.type.default.hoverBackgroundColor;
    }, function (props) {
      return props.theme.icon.type.primary.hoverColor;
    }, function (props) {
      return props.theme.icon.type.primary.hoverBackgroundColor;
    }, function (props) {
      return props.theme.icon.type.success.hoverColor;
    }, function (props) {
      return props.theme.icon.type.success.hoverBackgroundColor;
    }, function (props) {
      return props.theme.icon.type.warning.hoverColor;
    }, function (props) {
      return props.theme.icon.type.warning.hoverBackgroundColor;
    }, function (props) {
      return props.theme.icon.type.danger.hoverColor;
    }, function (props) {
      return props.theme.icon.type.danger.hoverBackgroundColor;
    }, function (props) {
      return props.theme.button.type.secondary.textColorPressed;
    }, _StyledIcon.default, function (props) {
      return props.theme.icon.borderRadius;
    }, function (props) {
      return props.theme.icon.type.default.pressedColor;
    }, function (props) {
      return props.theme.icon.type.default.pressedBackgroundColor;
    }, function (props) {
      return props.theme.icon.type.primary.pressedColor;
    }, function (props) {
      return props.theme.icon.type.primary.pressedBackgroundColor;
    }, function (props) {
      return props.theme.icon.type.success.pressedColor;
    }, function (props) {
      return props.theme.icon.type.success.pressedBackgroundColor;
    }, function (props) {
      return props.theme.icon.type.warning.pressedColor;
    }, function (props) {
      return props.theme.icon.type.warning.pressedBackgroundColor;
    }, function (props) {
      return props.theme.icon.type.danger.pressedColor;
    }, function (props) {
      return props.theme.icon.type.danger.pressedBackgroundColor;
    }, function (props) {
      return props.tabfocus && (0, _ykbStyledComponents.css)([".text ", ":only-child{box-shadow:", ";border-radius:", ";&.default-color{color:", ";background-color:", ";}&.primary-color{color:", ";background-color:", ";}&.success-color{color:", ";background-color:", ";}&.warning-color{color:", ";background-color:", ";}&.danger-color{color:", ";background-color:", ";}}"], _StyledIcon.default, function (props) {
        return props.theme.icon.boxShadow;
      }, function (props) {
        return props.theme.icon.borderRadius;
      }, function (props) {
        return props.theme.icon.type.default.focusColor;
      }, function (props) {
        return props.theme.icon.type.default.focusBackgroundColor;
      }, function (props) {
        return props.theme.icon.type.primary.focusColor;
      }, function (props) {
        return props.theme.icon.type.primary.focusBackgroundColor;
      }, function (props) {
        return props.theme.icon.type.success.focusColor;
      }, function (props) {
        return props.theme.icon.type.success.focusBackgroundColor;
      }, function (props) {
        return props.theme.icon.type.warning.focusColor;
      }, function (props) {
        return props.theme.icon.type.warning.focusBackgroundColor;
      }, function (props) {
        return props.theme.icon.type.danger.focusColor;
      }, function (props) {
        return props.theme.icon.type.danger.focusBackgroundColor;
      });
    }, function (props) {
      return props.theme.button.type.secondary.textColorDisabled;
    }, _StyledIcon.default, _StyledIcon.default, function (props) {
      return props.theme.icon.type.default.disabledColor;
    }, _StyledIcon.default, function (props) {
      return props.theme.icon.type.primary.disabledColor;
    }, _StyledIcon.default, function (props) {
      return props.theme.icon.type.success.disabledColor;
    }, _StyledIcon.default, function (props) {
      return props.theme.icon.type.warning.disabledColor;
    }, _StyledIcon.default, function (props) {
      return props.theme.icon.type.danger.disabledColor;
    }, StyledButtonContent) : (0, _ykbStyledComponents.css)(["&&{color:", ";background-color:", ";border-color:", ";&:hover{@media (min-width:768px){color:", ";background-color:", ";border-color:", ";}}", " &:active{color:", ";background-color:", ";border-color:", ";}&:disabled{cursor:not-allowed;color:", ";background-color:", ";border-color:", ";", "{pointer-events:none;}}}"], props.theme.button.type[props.colorType].textColor, props.theme.button.type[props.colorType].backgroundColor, props.theme.button.type[props.colorType].borderColor, props.theme.button.type[props.colorType].textColorHover, props.theme.button.type[props.colorType].backgroundColorHover, props.theme.button.type[props.colorType].borderColorHover, function (props) {
      return props.tabfocus && (0, _ykbStyledComponents.css)(["box-shadow:", ";color:", ";background-color:", ";border-color:", ";"], function (props) {
        return props.theme.button.focusBoxShadow;
      }, props.theme.button.type[props.colorType].textColorHover, props.theme.button.type[props.colorType].backgroundColorHover, props.theme.button.type[props.colorType].borderColorHover);
    }, props.theme.button.type[props.colorType].textColorPressed, props.theme.button.type[props.colorType].backgroundColorPressed, props.theme.button.type[props.colorType].borderColorPressed, props.theme.button.type[props.colorType].textColorDisabled, props.theme.button.type[props.colorType].backgroundColorDisabled, props.theme.button.type[props.colorType].borderColorDisabled, StyledButtonContent);
  }
};
var StyledABase = Base.withComponent('a');

// Add Types
var Button = (0, _ykbStyledComponents.default)(Base).attrs({
  className: 'ykb-button'
}).withConfig({
  componentId: "ykb-ui__sc-1ibjy4q-2"
})(["", ""], function (props) {
  return props.link || props.colorType == 'link' ? buttonView.Link(props) : buttonView.Button(props);
});
var Link = exports.Link = (0, _ykbStyledComponents.default)(StyledABase).attrs({
  className: 'ykb-button-link'
}).withConfig({
  componentId: "ykb-ui__sc-1ibjy4q-3"
})(["", ""], function (props) {
  return buttonView.Link(props);
});
var _default = exports.default = Button;